import { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { connect } from "../../redux/blockchain/blockchainActions";
import { fetchData } from "../../redux/data/dataActions";
import { Container, Row, Card, Button, Col } from "react-bootstrap";
import Particle from "../Particle2";
import hidden from "../../assets/images/clocks.jpg";
import Footer from "../Footer";



function MintNFT(props) {
  const dispatch = useDispatch();
  const blockchain = useSelector((state) => state.blockchain);
  const data = useSelector((state) => state.data);
  const [feedback, setFeedback] = useState("Mint your awesome RaceCar today...");
  const [nftsToBuy, setnftsToBuy] = useState(1);
  const [claimingNft, setClaimingNft] = useState(false);
  const [allMinted, setAllMinted] = useState(false);

  const claimNFTs = (_amount) => {
    if (_amount <= 0) {
      return;
    }
    setFeedback("Minting your DCRC RACE NFT...");
    setClaimingNft(true);
    blockchain.mbsaBullNFT.methods
      .mint(blockchain.account, _amount)
      .send({
        // gasLimit: "300000",
        to: "0x27c5D2127c0E540Cd3c31dae71702ACe2C80E861",
        from: blockchain.account,
        value: blockchain.web3.utils.toWei((data.cost * _amount).toString(), "ether"),
      })
      .once("error", (err) => {
        console.log(err);
        setFeedback("Sorry, something went wrong please try again later.");
        setClaimingNft(false);
      })
      .then((receipt) => {
        setFeedback(
          "WOW, you now own a DCRC NFT. View your NFTs on the MyNFTs page."
        );
        setClaimingNft(false);
        dispatch(fetchData(blockchain.account));
      });
  };

  const getData = () => {
    if (blockchain.account !== "" && blockchain.coolCowsNFT !== null) {
      dispatch(fetchData(blockchain.account));
    }
  };

  useEffect(() => {
    getData();
    if(data.totalSupply == data.maxSupply){
      setAllMinted(true);
    }
  }, [blockchain.account]);

  const incNFTs = () => {
    if(nftsToBuy < data.maxMintAmount){
      setnftsToBuy(nftsToBuy+1);
    }
  }

  const decNFTs = () => {
    if(nftsToBuy > 1){
      setnftsToBuy(nftsToBuy-1);
    }
  }

  return (
    <section>
      <Container fluid className="home-section" id="Minter">
        {/* <Particle /> */}
        <Container >
        <Row style={{ justifyContent: "center", paddingTop: "100px", paddingBottom: "10px" }}>
        <h1 className="nftgallery-heading">
          <strong className="purple">Mint your DCRC NFT Now...</strong>
        </h1><br/>
        </Row>
        <Row style={{ justifyContent: "center", paddingBottom: "10px", borderRadius: "20px"}}>
          <Col md={4} className="sinfo-mint-view" style={{ justifyContent: "center", paddingBottom: "10px", paddingTop: "10px", borderRadius: "10px" }}>
          <Card className="sinfo-mint-view">
            <Card.Title style={{ textAlign: "center", paddingTop: "20px" }}>DCRC RACE NFT</Card.Title>
            <Card.Img variant="top" src={hidden} alt="MBSA BULL NFT" />
            <Card.Body>
                <Button variant="number" 
                // disabled={claimingNft || allMinted ? 1 : 0}
                      onClick={(e) => {
                        e.preventDefault();
                        decNFTs();
                      }}
>
                {claimingNft ? "-" : "-"}
                </Button>
                <Button variant="primary" disabled={claimingNft ? 1 : 0}
                      onClick={(e) => {
                        e.preventDefault();
                        claimNFTs(nftsToBuy);
                        getData();
                      }}
>
                {claimingNft ? "BUSY" : "Buy " + nftsToBuy}
                </Button>
                <Button variant="number" 
                // disabled={claimingNft ? 1 : 0}
                      onClick={(e) => {
                        e.preventDefault();
                        incNFTs();
                      }}
>
                {claimingNft ? "+" : "+"}
                </Button>
                <br/>
                <br/>
                <p >Total Cost is {nftsToBuy*(data.cost)} AVAX</p>
                <p >{data.totalSupply} of {data.maxSupply} Minted</p>
                <p id="status">{feedback}</p>
                <p>All NFTs will be Revealed within 48hrs from the minting time!</p>
            </Card.Body>
        </Card>
            </Col>
          </Row>
        <Row style={{ justifyContent: "center", paddingTop: "1px", paddingBottom: "10px" }}>
         <a href="https://cchain.explorer.avax.network/address/0x27c5D2127c0E540Cd3c31dae71702ACe2C80E861" target="_blank"> View our Contract : Address -- 0x27c5D2127c0E540Cd3c31dae71702ACe2C80E861</a>
         <div className="nftmint-disc">
          <label className="white">* Please make sure you are connected to the Correct Network (Avalanche) and correct contract. Once you make accept the transaction it cannot be reversed.</label>
         </div>
        </Row>
          
          <Row style={{ justifyContent: "center", paddingTop: "60px", paddingBottom: "20px" }}></Row>
          <Footer />
        </Container>
      </Container>
    </section>
  )
}

export default MintNFT
